import { httpClient } from "../utils/HttpClient";

const getAll = (page_no, filter_name) => {
  return httpClient.get("/admin/lecturer", {
    params: {
      page: page_no,
      name: filter_name,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const get = (lecturer_id) => {
  return httpClient.get(`/admin/lecturer/${lecturer_id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const create = (data) => {
  return httpClient.post("/admin/lecturer", data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const update = (lecturer_id, data) => {
  return httpClient.patch(`/admin/lecturer/${lecturer_id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const remove = (lecturer_id) => {
  return httpClient.delete(`/admin/lecturer/${lecturer_id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const updateStatus = (lecturer_id, data) => {
  return httpClient.patch(`/admin/lecturer/status/${lecturer_id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export default {
  getAll,
  get,
  create,
  update,
  remove,
  updateStatus,
};
